var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"download"},[(_vm.isWX)?_c('p',{staticClass:"tip"},[_vm._v(" "+_vm._s(_vm.msg)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }